export default __webpack_public_path__ + "static/media/donating.383a4c35.png";